module.exports = __webpack_public_path__ + "img/poster.05206c5e.jpg";